export class InvalidInputError {

    constructor(public Message: string, public FriendlyTitle?: string, public FriendlyMessage?: string) {

    }

}
